export class HTTPValidationError {
  detail?: {
    loc?: string[];
    msg?: string;
    type?: string;
  }[];
}
